import { action, computed, makeObservable, observable } from 'mobx';

import { ILocalStore } from 'stores/interfaces';
import { EntryText } from 'stores/models';

type PrivateFields = '_error';

class RegisterStore implements ILocalStore {
  constructor() {
    makeObservable<RegisterStore, PrivateFields>(this, {
      _error: observable.ref,
      error: computed,
      setError: action.bound,
    });
  }

  private _error = false;

  readonly passwordEntry = new EntryText({
    defaultValue: '',
    required: true,
  });

  readonly repeatPasswordEntry = new EntryText({
    defaultValue: '',
    required: true,
  });

  get error(): boolean {
    return this._error;
  }

  setError(): void {
    this._error = true;
  }

  destroy() {
    this.passwordEntry.destroy();
    this.repeatPasswordEntry.destroy();
  }
}

export default RegisterStore;
